var exports = {
  "kL": "xcc377c0b--c513ad--container",
  "Sl": "xcc377c0b--c513ad--image",
  "DD": "xcc377c0b--c513ad--title",
  "Qs": "xcc377c0b--c513ad--content",
};

module.exports = exports;
